/* global window */
import cookie from 'react-cookies'
import * as types from '../actions/types'

const initialState = null

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.AUTH_USER_COMPLETE: {
      if (payload.stayLogged) {
        const localStorage = window.localStorage
        localStorage.setItem('user', JSON.stringify(payload))
      } else {
        cookie.save('user', payload, { path: '/' })
      }
      return payload
    }
    case types.FETCH_USER_INFORMATION: {
      const localStorage = window.localStorage
      const localUser = JSON.parse(localStorage.getItem('user'))
      const newUser = {
        ...localUser,
        ...payload,
      }
      localStorage.setItem('user', JSON.stringify(newUser))
      return {
        ...state,
        ...newUser,
      }
    }
    case types.NETWORK_LOGOUT:
    case types.USER_LOGOUT: {
      const localStorage = window.localStorage
      localStorage.removeItem('user')
      cookie.remove('user', { path: '/' })
      return initialState
    }
    case types.LOAD_LOCAL_USER: {
      if (typeof (window) !== 'undefined') {
        const sessionUser = cookie.load('user')
        if (sessionUser) {
          return {
            ...sessionUser,
            ...state,
          }
        }
        const localStorage = window.localStorage
        const localUser = JSON.parse(localStorage.getItem('user')) || initialState
        return {
          ...localUser,
          ...state,
        }
      }
      return state
    }
    default:
      return state
  }
}
